import React from "react";
import { Typography } from "@mui/material";
import PageHeader from "../../shared/components/PageHeader";
import useNavMenu from "../../shared/useNavMenu";

// Page-header definition for the legacy v1 Scheduling pages (Terms, School Days,
// Day Templates, Class Schedules). The tab list resolves from the navigation
// registry (useNavMenu), permission-gated the same way the nav menu is. The
// selected school year's date range is the page's only "action": v1 formats it
// (it owns moment) and hands the finished string over, so no date library
// crosses the bridge.
export default function SchedulingHeader({ dateRangeLabel }) {
  const { tabs, activeKey } = useNavMenu("scheduling");

  return (
    <PageHeader
      title="Scheduling"
      tabs={tabs}
      activeTab={activeKey}
      actions={
        dateRangeLabel ? (
          <Typography
            sx={{
              whiteSpace: "nowrap",
              textAlign: "right",
              width: "100%",
              color: "text.secondary",
            }}
          >
            {dateRangeLabel}
          </Typography>
        ) : null
      }
    />
  );
}
